import { apiClient } from "../../lib";

export interface User {
  user_id: number,
  full_name: string,
  email: string,
  is_stake_holders: boolean,
  role: string,
  layout_id: number,
  is_active: string
};

export interface GetUsersResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: string;
  data: User[];
};

export interface GetUserResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: string;
  data: User;
};

export interface Stakeholder {
  id: number,
  first_name: string,
  last_name: string,
  full_name: string,
  email: string,
  role: string,
  role_access: string,
  phone_number: string,
  created_at: string,
  created_by: string | null,
  updated_at: string,
  updated_by: string | null,
  is_active: string,
  is_stake_holders: boolean
};

export interface StakeholderResponse {
  status: boolean;
  http_code: number;
  message: string;
  response_time: string;
  meta_data: string;
  data: Stakeholder[];
};

export const usersApi = {
  getUsers: async (): Promise<GetUsersResponse> => {
    const response = await apiClient.get("/users");
    return response.data;
  },
  getJeopardyStakeholders: async ({ params }: { params?: Record<string, any> }): Promise<GetUsersResponse> => {
    const response = await apiClient.get("/projects/stake-holders-dropdown", { params });
    return response.data;
  }
};